import { BRAND_LOGOS } from "@/data/content";
import SectionBadge from "@/components/site/SectionBadge";
import LogoCard from "@/components/site/LogoCard";

export default function TrustedBy() {
  // duplicate the list so the marquee loops seamlessly
  const loop = [...BRAND_LOGOS, ...BRAND_LOGOS];

  return (
    <section
      id="trusted"
      data-testid="trusted-section"
      className="py-16 md:py-20 bg-white border-y border-zinc-200"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 md:px-12">
        <SectionBadge label="Leadership Experience" />
        <div className="mt-6 flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-10 md:mb-12">
          <h2 className="font-serif-display text-3xl md:text-4xl leading-tight">
            16+ years of business transformation
            <br className="hidden md:block" /> across category-defining brands.
          </h2>
          <p className="text-base text-zinc-700 leading-relaxed max-w-md">
            Consulting engagements and leadership tenures across Fortune 500
            MNCs, listed companies and high-growth startups.
          </p>
        </div>
      </div>

      {/* Full-bleed marquee for continuous horizontal scroll */}
      <div
        data-testid="trusted-marquee"
        className="relative overflow-hidden"
        style={{
          maskImage:
            "linear-gradient(to right, transparent, black 8%, black 92%, transparent)",
          WebkitMaskImage:
            "linear-gradient(to right, transparent, black 8%, black 92%, transparent)",
        }}
      >
        <div className="marquee-track py-2">
          {loop.map((brand, i) => (
            <LogoCard key={`${brand.name}-${i}`} name={brand.name} />
          ))}
        </div>
      </div>
    </section>
  );
}
